import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.w56_1 = new (HttpStatusCode())(100, 'Continue');
        this.x56_1 = new (HttpStatusCode())(101, 'Switching Protocols');
        this.y56_1 = new (HttpStatusCode())(102, 'Processing');
        this.z56_1 = new (HttpStatusCode())(200, 'OK');
        this.a57_1 = new (HttpStatusCode())(201, 'Created');
        this.b57_1 = new (HttpStatusCode())(202, 'Accepted');
        this.c57_1 = new (HttpStatusCode())(203, 'Non-Authoritative Information');
        this.d57_1 = new (HttpStatusCode())(204, 'No Content');
        this.e57_1 = new (HttpStatusCode())(205, 'Reset Content');
        this.f57_1 = new (HttpStatusCode())(206, 'Partial Content');
        this.g57_1 = new (HttpStatusCode())(207, 'Multi-Status');
        this.h57_1 = new (HttpStatusCode())(300, 'Multiple Choices');
        this.i57_1 = new (HttpStatusCode())(301, 'Moved Permanently');
        this.j57_1 = new (HttpStatusCode())(302, 'Found');
        this.k57_1 = new (HttpStatusCode())(303, 'See Other');
        this.l57_1 = new (HttpStatusCode())(304, 'Not Modified');
        this.m57_1 = new (HttpStatusCode())(305, 'Use Proxy');
        this.n57_1 = new (HttpStatusCode())(306, 'Switch Proxy');
        this.o57_1 = new (HttpStatusCode())(307, 'Temporary Redirect');
        this.p57_1 = new (HttpStatusCode())(308, 'Permanent Redirect');
        this.q57_1 = new (HttpStatusCode())(400, 'Bad Request');
        this.r57_1 = new (HttpStatusCode())(401, 'Unauthorized');
        this.s57_1 = new (HttpStatusCode())(402, 'Payment Required');
        this.t57_1 = new (HttpStatusCode())(403, 'Forbidden');
        this.u57_1 = new (HttpStatusCode())(404, 'Not Found');
        this.v57_1 = new (HttpStatusCode())(405, 'Method Not Allowed');
        this.w57_1 = new (HttpStatusCode())(406, 'Not Acceptable');
        this.x57_1 = new (HttpStatusCode())(407, 'Proxy Authentication Required');
        this.y57_1 = new (HttpStatusCode())(408, 'Request Timeout');
        this.z57_1 = new (HttpStatusCode())(409, 'Conflict');
        this.a58_1 = new (HttpStatusCode())(410, 'Gone');
        this.b58_1 = new (HttpStatusCode())(411, 'Length Required');
        this.c58_1 = new (HttpStatusCode())(412, 'Precondition Failed');
        this.d58_1 = new (HttpStatusCode())(413, 'Payload Too Large');
        this.e58_1 = new (HttpStatusCode())(414, 'Request-URI Too Long');
        this.f58_1 = new (HttpStatusCode())(415, 'Unsupported Media Type');
        this.g58_1 = new (HttpStatusCode())(416, 'Requested Range Not Satisfiable');
        this.h58_1 = new (HttpStatusCode())(417, 'Expectation Failed');
        this.i58_1 = new (HttpStatusCode())(422, 'Unprocessable Entity');
        this.j58_1 = new (HttpStatusCode())(423, 'Locked');
        this.k58_1 = new (HttpStatusCode())(424, 'Failed Dependency');
        this.l58_1 = new (HttpStatusCode())(425, 'Too Early');
        this.m58_1 = new (HttpStatusCode())(426, 'Upgrade Required');
        this.n58_1 = new (HttpStatusCode())(429, 'Too Many Requests');
        this.o58_1 = new (HttpStatusCode())(431, 'Request Header Fields Too Large');
        this.p58_1 = new (HttpStatusCode())(500, 'Internal Server Error');
        this.q58_1 = new (HttpStatusCode())(501, 'Not Implemented');
        this.r58_1 = new (HttpStatusCode())(502, 'Bad Gateway');
        this.s58_1 = new (HttpStatusCode())(503, 'Service Unavailable');
        this.t58_1 = new (HttpStatusCode())(504, 'Gateway Timeout');
        this.u58_1 = new (HttpStatusCode())(505, 'HTTP Version Not Supported');
        this.v58_1 = new (HttpStatusCode())(506, 'Variant Also Negotiates');
        this.w58_1 = new (HttpStatusCode())(507, 'Insufficient Storage');
        this.x58_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.x58_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp$ret$2 = element.z58_1;
          destination.x4(tmp$ret$2, element);
        }
        tmp.y58_1 = destination;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpStatusCodeClass;
function HttpStatusCode() {
  if (HttpStatusCodeClass === VOID) {
    class $ {
      constructor(value, description) {
        Companion_getInstance();
        this.z58_1 = value;
        this.a59_1 = description;
      }
      toString() {
        return '' + this.z58_1 + ' ' + this.a59_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof HttpStatusCode()) {
          tmp = other.z58_1 === this.z58_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.z58_1;
      }
      b59(other) {
        return this.z58_1 - other.z58_1 | 0;
      }
      d(other) {
        return this.b59(other instanceof HttpStatusCode() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HttpStatusCode', VOID, VOID, [Comparable()]);
    HttpStatusCodeClass = $;
  }
  return HttpStatusCodeClass;
}
function allStatusCodes() {
  return listOf([Companion_getInstance().w56_1, Companion_getInstance().x56_1, Companion_getInstance().y56_1, Companion_getInstance().z56_1, Companion_getInstance().a57_1, Companion_getInstance().b57_1, Companion_getInstance().c57_1, Companion_getInstance().d57_1, Companion_getInstance().e57_1, Companion_getInstance().f57_1, Companion_getInstance().g57_1, Companion_getInstance().h57_1, Companion_getInstance().i57_1, Companion_getInstance().j57_1, Companion_getInstance().k57_1, Companion_getInstance().l57_1, Companion_getInstance().m57_1, Companion_getInstance().n57_1, Companion_getInstance().o57_1, Companion_getInstance().p57_1, Companion_getInstance().q57_1, Companion_getInstance().r57_1, Companion_getInstance().s57_1, Companion_getInstance().t57_1, Companion_getInstance().u57_1, Companion_getInstance().v57_1, Companion_getInstance().w57_1, Companion_getInstance().x57_1, Companion_getInstance().y57_1, Companion_getInstance().z57_1, Companion_getInstance().a58_1, Companion_getInstance().b58_1, Companion_getInstance().c58_1, Companion_getInstance().d58_1, Companion_getInstance().e58_1, Companion_getInstance().f58_1, Companion_getInstance().g58_1, Companion_getInstance().h58_1, Companion_getInstance().i58_1, Companion_getInstance().j58_1, Companion_getInstance().k58_1, Companion_getInstance().l58_1, Companion_getInstance().m58_1, Companion_getInstance().n58_1, Companion_getInstance().o58_1, Companion_getInstance().p58_1, Companion_getInstance().q58_1, Companion_getInstance().r58_1, Companion_getInstance().s58_1, Companion_getInstance().t58_1, Companion_getInstance().u58_1, Companion_getInstance().v58_1, Companion_getInstance().w58_1]);
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstancek3kgntyryryj,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
};
//endregion

//# sourceMappingURL=HttpStatusCode.mjs.map
